
import { StateCreator } from 'zustand';
import { GridBundleSlice, GridFilters } from '../gridTypes';
import { setFilterPropertyHandler } from '../gridUtils';

type ImmerStateCreator<T> = StateCreator<
  T,
  [["zustand/immer", never], never],
  [],
  T
>;

const initialState: GridFilters = {
    sort: 'sortOrder,desc',
    conditionFilter: [],
    sizeFilter: [],
    minPrice: undefined,
    maxPrice: undefined,
    isInitialState: true,
    groupId: undefined,
    customerStoreId:undefined,
    shippingTypeId:[],
    pageSize: undefined,
    sellerId: undefined,
    cartCode: undefined,
    categoryId: undefined,
    excludeProductId: undefined,
}


export const createGridBundleSlice: ImmerStateCreator<GridBundleSlice> = (set) => ({
    gridBundleFilters: initialState,
    SET_BUNDLE_FILTER: (filterType, newValue) => {
        set((state) => {
            const {gridBundleFilters} = state
            const filterUpdated = setFilterPropertyHandler(gridBundleFilters, filterType, newValue)
            state.gridBundleFilters = {...filterUpdated, isInitialState: false}
        }, false, 'SET_BUNDLE_FILTER')
    },
    SET_BUNDLE_ALL_FILTER: (initialFilterBundles) => {
        set((state) => {
            state.gridBundleFilters = {...initialFilterBundles, isInitialState: false}
        }, false, 'SET_BUNDLE_ALL_FILTER')
    },
    RESET_BUNDLE_FILTER: () => {
        set((state) => {
            state.gridBundleFilters = {...state.gridBundleFilters, ...initialState}
        }, false, 'RESET_BUNDLE_FILTER')
    },
});

